export interface TrackedErrorExtras<TError> {
  content?: string;
  title?: string;
  source?: TError;
  tags?: {
    [key: string]: string;
  };
}

export class TrackedError<TError = Error> extends Error {
  static NAME = 'TrackedError';

  public extras: TrackedErrorExtras<TError>;

  constructor(extras: TrackedErrorExtras<TError>) {
    super(extras.content || 'TrackedError');

    this.name = TrackedError.NAME;
    this.extras = extras;

    // Bubble the tags up the error hierarchy
    this.extras.tags = this.extras.tags ?? (extras.source as unknown as TrackedError)?.extras?.tags;

    if (extras.content) {
      const upperCasedContent = extras.content.charAt(0).toUpperCase() + extras.content.slice(1);
      this.name = `${TrackedError.NAME} - ${upperCasedContent}`;
    }
  }
}

export function isTrackedError(error: Error | null): error is TrackedError {
  return Boolean(error?.name.startsWith(TrackedError.NAME));
}

export function isBoundaryError(error: Error | null): error is BoundaryError {
  return Boolean(error?.name.startsWith(BoundaryError.NAME));
}

export function shouldIgnoreError(error: Error): boolean {
  return !(isBoundaryError(error) || isTrackedError(error));
}

export class BoundaryError extends Error {
  static NAME = 'BoundaryError';

  constructor(message: string) {
    super(message);

    this.name = BoundaryError.NAME;
  }
}
